"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'rag.file.indexing_error': 'File indexing failed. Please try again or contact support if the problem persists.',
};
